import { Box, Card, Chip, Divider, IconButton, Tooltip, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import Grid from '@mui/material/Grid2'
import AnalysisMap1 from '../../../../resources/images/analysismap1.png'
import { useEffect, useRef, useState } from 'react';
import { MapCardComponent, MapDetailComponent } from '../../../common/mapCardComponent';
import { ReactComponent as Observation } from '../../../../resources/images/observation.svg';
import { ReactComponent as Species } from '../../../../resources/images/specie.svg';
import { ReactComponent as Camera } from '../../../../resources/images/cam.svg';
import { ReactComponent as Audio } from '../../../../resources/images/aud.svg';
import { ChartComponent } from '../../../common/chartComponent';
import { ChartData } from '../../../../mock';
import { useLocation, useNavigate } from 'react-router-dom';
import { getProjectByName } from '../../../../utils/mergeData';
import { SiteCard, SiteDetailCard } from '../../../common/detailComponent';
import SiteArea from '../../../../resources/images/area-covered.svg'
import SiteCamera from '../../../../resources/images/sitecamera.svg'
import SiteAudio from '../../../../resources/images/siteaudio.svg'
import SiteSpecies from '../../../../resources/images/sitespecies.svg'
import SiteImage from '../../../../resources/images/siteimg.svg'
import SiteFile from '../../../../resources/images/sitefile.svg'
import SiteMap from '../SiteMap';
import BiodiversityDownloadFilter from './BiodiversityDownloadFilter';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts'
import { getSpeciesAbundanceRangeCategory, getPotentialRangeCategory, getIntactnessRangeCategory, getShannonRangeCategory, getTaxonomicDissimilarityRangeCategory, getHabitatHealthRangeCategory, getHumanIntrusionRangeCategory } from '../../../../constants/index';
import { convertToNumber } from '../../../../constants/index';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HumanImpact from '../../../../resources/images/Human_impact.png'
import Richness from '../../../../resources/images/SPECIES_RICHNESS.png'
import HealthHabitat from '../../../../resources/images/HABITAT_HEATH.jpeg'
import OverallHealth from '../../../../resources/images/OVERALL_HEALTH.png'
import Biomonitor from '../../../../resources/images/Biomonitor.svg'
import Monitoring from '../../../../resources/images/Monitoring.png'
import DMapBioAnalysis from '../DMap/DMpaBioAnalysis';
import SoilSensorCard from './SoilSensorCard';
import ExSituMetrics from './ExSituMetrics';



const BiodiversityAnalysisDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showNewComponent, setShowNewComponent] = useState(false);

  const selectedProjectStr = localStorage.getItem('selectedProject');
  const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;

  const currentProject = getProjectByName(selectedProject?.project_name);

  const siteDropDownDetailsRaw = JSON.parse(localStorage.getItem('SelectedDropDownSite') || 'null');
  const siteDetails = JSON.parse(localStorage.getItem('site') || 'null') || {};

  const isSiteSelected = Boolean(siteDropDownDetailsRaw && Object.keys(siteDropDownDetailsRaw).length > 0);
  // Default to project-level metrics merged with the first site as a fallback for missing fields
  const liveSiteData = currentProject?.sites?.find((s: any) => s.site_name === siteDropDownDetailsRaw?.site_name);
  const siteDropDownDetails = liveSiteData || siteDropDownDetailsRaw || { ...(currentProject?.sites?.[0] || {}), ...(currentProject?.biodiversity_summary_project_level || {}) };

  const getChartData = (currentProject as any)?.sites?.filter((i: any) => i.site_name === siteDropDownDetails.site_name || i.site_name === siteDetails.site_name);

  const filterSpeciesData = (getChartData ? siteDropDownDetails?.species_distribution : siteDetails?.species_distribution)
  const filterSpeciesDetectedRaw = (getChartData ? siteDropDownDetails?.species_detected : siteDetails?.species_detected)
  const filterSpeciesDetected: any[] = Array.isArray(filterSpeciesDetectedRaw) && filterSpeciesDetectedRaw.length > 0 ? filterSpeciesDetectedRaw : [{}];

  const speciesData = [
    {
      name: 'Critically Endangered',
      value1: parseInt(filterSpeciesData ? filterSpeciesData[0]?.critically_endangered[0]?.total : '0'),
      species: filterSpeciesData ? filterSpeciesData[0]?.critically_endangered[0]?.species_list.join(', ') : ''
    },
    {
      name: 'Endangered',
      value1: parseInt(filterSpeciesData ? filterSpeciesData[0]?.endangered[0]?.total : '0'),
      species: filterSpeciesData ? filterSpeciesData[0]?.endangered[0]?.species_list.join(', ') : ''
    },
    {
      name: 'Vulnerable',
      value1: parseInt(filterSpeciesData ? filterSpeciesData[0]?.vulnerable[0]?.total : '0'),
      species: filterSpeciesData ? filterSpeciesData[0]?.vulnerable[0]?.species_list.join(', ') : ''
    },
    {
      name: 'Near Threatened',
      value1: parseInt(filterSpeciesData ? filterSpeciesData[0]?.near_threatened[0]?.total : '0'),
      species: filterSpeciesData ? filterSpeciesData[0]?.near_threatened[0]?.species_list.join(', ') : ''
    },
    {
      name: 'Least Concern',
      value1: parseInt(filterSpeciesData ? filterSpeciesData[0]?.least_concerned[0]?.total : '0'),
      species: filterSpeciesData ? filterSpeciesData[0]?.least_concerned[0]?.species_list.join(', ') : ''
    },
  ];
  const speciesFilterData = speciesData.map(item => ({
    name: item.name,
    y: item.value1,
    description: item.species.split(', ').map((species: any) => `<br/>- ${species}`).join(''),
  }));

  const speciesOptions = {
    chart: {
      type: 'pie',
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      pointFormat: `
            Total No.: <b>{point.y}</b><br/>
            Species: <b>{point.description}</b><br/>
            Percentage: <b>{point.percentage:.1f}%</b>
        `,
    },
    legend: {
      enabled: true, // Ensure the legend is enabled
      layout: 'horizontal', // Arrange legends vertically
      align: 'center', // Align legends to the right
      verticalAlign: 'bottom', // Vertically align legends to the middle
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          distance: -30,
          enabled: true,
          format: `<b>{point.y}</b><br/>`,
          style: {
            color: '#ffffff',
            fontSize: '14px',
            fontWeight: 'bold',
          },
        },
        innerSize: '50%', // For donut effect
      },
    },
    series: [
      {
        name: 'Species',
        colorByPoint: true,
        showInLegend: true, // Enable legends for this series
        data: speciesFilterData, // Ensure this contains valid data
      },
    ],
  };


  const speciesDetected = filterSpeciesDetected[0] && Object.keys(filterSpeciesDetected[0]).length > 0
    ? Object.keys(filterSpeciesDetected[0]).map((year) => {
      const yearData = filterSpeciesDetected[0][year] || { image_species: [], audio_species: [] };
      const totalImages = yearData.image_species?.length || 0;
      const totalAudio = yearData.audio_species?.length || 0;
      return { year: `${year}`, images: totalImages, audio: totalAudio };
    })
    : [];

  // Ensure 2024 is included explicitly
  if (!speciesDetected.find((item) => item.year === "2024")) {
    speciesDetected.push({
      year: "2024",
      images: filterSpeciesDetected[0]["2024"]?.image_species?.length,// get the correct length
      audio: filterSpeciesDetected[0]["2024"]?.audio_species?.length,   // get the correct length
    });
  }

  // Map data for the chart
  const chartData = speciesDetected.map((item) => ({
    name: item.year,
    value1: item.images, // Images mapped to value1
    value2: item.audio,  // Audio mapped to value2
  }));

  const years = filterSpeciesDetected[0] ? Object.keys(filterSpeciesDetected[0]) : [];
  console.log('filterSpeciesDetected', filterSpeciesDetected['2023']?.image_species?.length)
  console.log('years', years)

  const seriesData = [
    {
      name: "Image", // Category 1
      data: years.map((year) => {
        const imageSpeciesCount = filterSpeciesDetected[0][year]?.image_species?.length || 0;

        return imageSpeciesCount; // Ensure we default to 0 if image_species is undefined
      }),
      color: "#7cb5ec", // Color for image
    },
    {
      name: "Audio", // Category 2
      data: years.map((year) => filterSpeciesDetected[0][year]?.audio_species?.length || 0), // Audio count
      color: "#434348", // Color for audio
    },
  ];

  const totalSpeciesDetected =
    siteDropDownDetails?.species_detected?.[0]
    || siteDetails?.species_detected?.[0]
    || null;

  if (!totalSpeciesDetected) {
    console.warn("No species detected data available.");
  }

  const totalSpecies = totalSpeciesDetected?.[2024]
    ? (Number(totalSpeciesDetected?.[2023]?.total_species) || 0) + (Number(totalSpeciesDetected?.[2024]?.total_species) || 0)
    : Number(totalSpeciesDetected?.[2023]?.total_species) || 0;

  const totalCamera = totalSpeciesDetected?.[2024]
    ? (Number(totalSpeciesDetected?.[2023]?.total_camera_images) || 0) + (Number(totalSpeciesDetected?.[2024]?.total_camera_images) || 0)
    : Number(totalSpeciesDetected?.[2023]?.total_camera_images) || 0;

  const totalAudio = totalSpeciesDetected?.[2024]
    ? (Number(totalSpeciesDetected?.[2023]?.total_audio_files) || 0) + (Number(totalSpeciesDetected?.[2024]?.total_audio_files) || 0)
    : Number(totalSpeciesDetected?.[2023]?.total_audio_files) || 0;

  const totalSpeciesFile =
    Number(siteDropDownDetails?.species_detected?.[0]?.[2023]?.total_species ?? 0) +
    Number(siteDropDownDetails?.species_detected?.[0]?.[2024]?.total_species ?? 0);

  const totalAudioFiles =
    Number(siteDropDownDetails?.species_detected?.[0]?.[2023]?.total_audio_files ?? 0) +
    Number(siteDropDownDetails?.species_detected?.[0]?.[2024]?.total_audio_files ?? 0);

  const totalCameraImages =
    Number(siteDropDownDetails?.species_detected?.[0]?.[2023]?.total_camera_images ?? 0) +
    Number(siteDropDownDetails?.species_detected?.[0]?.[2024]?.total_camera_images ?? 0);

  const containerRef = useRef<HTMLDivElement>(null);

  const bioTrendScore = siteDropDownDetails.biodiversity_score_trend;
  const bioIntactnessTrendScore = siteDropDownDetails.biodiversity_intactness_trend;
  const meanSpeciesTrendScore = siteDropDownDetails.mean_species_abundance_trend;
  const speciesActivityTrendScore = siteDropDownDetails.species_activity_trend;
  const potentialTrendScore = siteDropDownDetails.potential_disappearance_fraction_trend;
  const humanActivityTrendScore = siteDropDownDetails.human_activity_trend;

  const bioTrendScoreData = bioTrendScore
    ? Object.keys(bioTrendScore[0]).map((year) => ({
      name: year,
      value1: parseFloat(bioTrendScore[0][year]), // Use parseFloat to handle decimals
    }))
    : [];
  const bioIntactnessScoreData = bioIntactnessTrendScore
    ? Object.keys(bioIntactnessTrendScore[0]).map((year) => ({
      name: year,
      value1: parseFloat(bioIntactnessTrendScore[0][year]), // Use parseFloat to handle decimals
    }))
    : [];
  const meanSpeciesScoreData = meanSpeciesTrendScore
    ? Object.keys(meanSpeciesTrendScore[0]).map((year) => ({
      name: year,
      value1: parseFloat(meanSpeciesTrendScore[0][year]), // Use parseFloat to handle decimals
    }))
    : [];
  const speciesActivityScoreData = speciesActivityTrendScore
    ? Object.keys(speciesActivityTrendScore[0]).map((year) => ({
      name: year,
      value1: parseFloat(speciesActivityTrendScore[0][year]), // Use parseFloat to handle decimals
    }))
    : [];
  const potentialFractionTrendScoreData = potentialTrendScore
    ? Object.keys(potentialTrendScore[0]).map((year) => ({
      name: year,
      value1: parseFloat(potentialTrendScore[0][year]), // Use parseFloat to handle decimals
    }))
    : [];
  const humanActivityTrendScoreData = humanActivityTrendScore
    ? Object.keys(humanActivityTrendScore[0]).map((year) => ({
      name: year,
      value1: parseFloat(humanActivityTrendScore[0][year]), // Use parseFloat to handle decimals
    }))
    : [];


  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  }, []);

  const icons = [<Species />, <Camera />, <Audio />];
  const dataTitle = ['Total species detected', 'Species detected by camera', 'Species detected by Audio'];
  const amount = [totalSpecies, totalCamera, totalAudio];

  const handleDownloadData = () => {
    // navigate('/biodiversity-species-data', { replace: true })
    setShowNewComponent(true);
  }
  const handleCredit = () => {
    navigate('/biodiversitycredits', { state: siteDropDownDetails })
  }
  const config = {
    chart: {
      type: "column", // Stacked column chart
    },
    title: {
      text: null, // Title of the chart
    },
    xAxis: {
      categories: years, // Use years as categories on the x-axis
      title: {
        text: "Year", // Label for x-axis
      },
    },
    yAxis: {
      min: 0, // Set minimum value for y-axis
      title: {
        text: "Number of Observations", // Label for y-axis
      },
      stackLabels: {
        enabled: true, // Enable stack labels on bars
        style: {
          fontWeight: "bold", // Style for stack labels
          color: "black", // Color for stack labels (white)
        },
      },
    },
    tooltip: {
      shared: true, // Share tooltip for stacked bars
      formatter: function (this: Highcharts.TooltipFormatterContextObject): string {
        return `<b>${this.x}</b><br/>` +
          this.points
            ?.map(
              (point) =>
                `<span style="color:${point.color}">\u25CF</span> ${point.series.name}: ${point.y}`
            )
            .join("<br/>");
      },
    },
    plotOptions: {
      column: {
        stacking: "normal", // Enable stacking for column chart
        dataLabels: {
          enabled: true, // Enable data labels inside the columns
        },
      },
    },
    series: seriesData
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Box className="bio-map">
        {/* <SiteMap /> */}
        <DMapBioAnalysis siteDropDownDetails={siteDropDownDetails} />
      </Box>

      <SiteDetailCard siteTitle={siteDropDownDetails?.site_name || siteDetails?.site_name} siteDetail={siteDropDownDetails?.type || siteDetails?.type} />
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ m: 1.5 }}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SiteCard
            title={'Area Covered'}
            amount={siteDropDownDetails?.area}
            icon={SiteArea} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SiteCard
            title={'Cameras Installed'}
            amount={siteDropDownDetails?.camera_installed ?? siteDropDownDetails?.cameras_installed}
            icon={SiteCamera} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SiteCard
            title={'Audio Devices'}
            amount={siteDropDownDetails?.audio_devices ?? siteDropDownDetails?.audio_devices_installed}
            icon={SiteAudio} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SiteCard
            title={'Species Identified'}
            amount={totalSpeciesFile}
            icon={SiteSpecies} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SiteCard
            title={'Images & Videos'}
            amount={totalCameraImages}
            icon={SiteImage} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SiteCard
            title={'Audio Files'}
            amount={totalAudioFiles}
            icon={SiteFile} />
        </Grid>
      </Grid>

      {siteDropDownDetails?.exsitu_data && (
        <ExSituMetrics data={siteDropDownDetails.exsitu_data} />
      )}



      <Box sx={{ m: 1 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 6 }}>
            <Card sx={{
              boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
              borderRadius: '8px',
              backgroundColor: '#fff',
            }}>
              <Typography
                component="div"
                sx={{ textAlign: "left", fontSize: "16px", fontWeight: 600, color: '#151E15', p: "16px" }}
              >{'Species Distribution by Threat Level'}
              </Typography>
              <Box className='divider' sx={{ p: 2 }} />
              <HighchartsReact highcharts={Highcharts} options={speciesOptions} />
            </Card>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <Card sx={{
              boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
              borderRadius: '8px',
              backgroundColor: '#fff',
            }}>
              <Typography
                component="div"
                sx={{ textAlign: "left", fontSize: "16px", fontWeight: 600, color: '#151E15', p: "16px" }}
              >{'No. of Observations per Species'}
              </Typography>
              <Box className='divider' sx={{ p: 2 }} />
              {/* <ChartComponent chartType={'bar'} chartTitle={''} data={chartData} title='Images/Audio' seriesValue1='Image' seriesValue2='Audio' /> */}
              {years.length > 0 && seriesData.length > 0 && (
                <HighchartsReact highcharts={Highcharts} options={config} />
              )}
            </Card>
          </Grid>
          {currentProject?.project_name && (
            <>
              <Grid size={{ xs: 6 }}>
                <ChartComponent chartType={'line'} chartTitle={'Biodiversity Score Trend'} data={bioTrendScoreData} title='Biodiversity Score' yTitle='Years' seriesValue1='Biodiversity Index Score' />
              </Grid>

              <Grid size={{ xs: 6 }}>
                <ChartComponent chartType={'line'} chartTitle={'Biodiversity Intactness Trend'} data={bioIntactnessScoreData} title=' Biodiversity Intactness Value' yTitle='Years' seriesValue1='Biodiversity Intactness Value' />
              </Grid>

              <Grid size={{ xs: 6 }}>
                <ChartComponent chartType={'line'} chartTitle={'Mean Species Abundance Trend'} data={meanSpeciesScoreData} title='Mean Species Abundance Score' yTitle='Years' seriesValue1='Mean Species Abundance Score' />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <ChartComponent chartType={'line'} chartTitle={'Potential Disappearance Fraction Trend'} data={potentialFractionTrendScoreData} title='Potential Disappearance Fraction Score' yTitle="Years" seriesValue1='Potential Disappearance Fraction' />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <ChartComponent chartType={'line'} chartTitle={'Species Activity Trend'} data={speciesActivityScoreData} title='No. of Recorded Activities' yTitle='Hours/Time of the day' seriesValue1='No. of Recorded Activities' />
              </Grid>
              <Grid size={{ xs: 6 }}>
                <ChartComponent chartType={'line'} chartTitle={'Human Activity Trend'} data={humanActivityTrendScoreData} title='No. of Recorded Activities' seriesValue1='No. of Recorded Activities' yTitle='Hours/Time of the day' />
              </Grid>
            </>
          )}
        </Grid>

        {(currentProject as any)?.eDNA && siteDropDownDetails && (
          <Box
            sx={{
              overflowY: 'auto',
              border: '1px solid #ccc',
              padding: '2px',
              backgroundColor: "#fff",
              mt: 5,
              borderRadius: '8px',
              boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
              position: 'relative' // Added for overlay
            }}
          >
            <Typography
              component="div"
              sx={{
                textAlign: "left",
                fontSize: "22px",
                fontWeight: 600,
                color: '#151E15',
                p: 2
              }}
            >
              {'eDNA Performance Metrics'}
            </Typography>

            <Box sx={{ position: 'relative' }}>
              <Grid container sx={{ filter: !siteDropDownDetails?.eDNA_data ? 'blur(1px)' : 'none', opacity: !siteDropDownDetails?.eDNA_data ? 0.6 : 1 }}>
                {[
                  {
                    section: 'Biodiversity',
                    icon: Biomonitor,
                    metrics: [
                      {
                        label: 'Total Taxa Detected',
                        value: `${siteDropDownDetails.eDNA_data?.total_taxa_detected || '--'} taxa`,
                        tooltip: 'The number of unique genetic signatures identified, representing the total variety of organisms found in the sample.',
                        color: 'green'
                      },
                      {
                        label: 'Mean Sample Richness',
                        value: `${siteDropDownDetails.eDNA_data?.mean_alpha_richness || '--'} taxa/sample`,
                        tooltip: 'The average number of distinct taxa found per individual sample.',
                        color: 'green'
                      },
                      {
                        label: 'Mean Shannon Diversity',
                        value: siteDropDownDetails.eDNA_data?.mean_shannon_index || '--',
                        tooltip: 'A statistical measure of biodiversity that accounts for both the number of species and their relative abundance.',
                        color: getShannonRangeCategory(convertToNumber(siteDropDownDetails.eDNA_data?.mean_shannon_index || 0)).color
                      },
                    ]
                  },
                  {
                    section: 'Community Structure',
                    icon: Richness,
                    metrics: [
                      {
                        label: 'Within-Site similarity',
                        value: `${siteDropDownDetails.eDNA_data?.mean_bray_curtis || '--'} similarity`,
                        tooltip: 'Measures how similar the eDNA profiles are between different samples taken from the same site.',
                        color: getIntactnessRangeCategory(convertToNumber(siteDropDownDetails.eDNA_data?.mean_bray_curtis || 0)).color
                      },
                    ]
                  },
                  {
                    section: 'Species Monitoring',
                    icon: Monitoring,
                    metrics: [
                      {
                        label: 'Tor sp. Conc.',
                        value: `${siteDropDownDetails.eDNA_data?.tor_sp_qpcr || '--'} copies/L`,
                        tooltip: 'The quantity of DNA fragments from Tor sp. species detected in the water, indicating its relative presence or biomass.',
                        color: 'green'
                      },
                      {
                        label: 'Frog Conc.',
                        value: `${siteDropDownDetails.eDNA_data?.paradoxus_frog_qpcr || '--'} copies/L`,
                        tooltip: 'The quantity of DNA fragments from Paradoxus Frog species detected in the water, indicating its relative presence or biomass.',
                        color: 'green'
                      },
                    ]
                  },
                  {
                    section: 'Data Quality',
                    icon: SiteFile,
                    metrics: [
                      {
                        label: 'Assigned Reads (QC)',
                        value: siteDropDownDetails.eDNA_data?.qc_assigned_reads || '--',
                        tooltip: 'The number of DNA sequence reads that passed quality control filters and were successfully mapped to specific taxa.',
                        color: '#666666'
                      },
                      {
                        label: 'PCR Concordance',
                        value: siteDropDownDetails.eDNA_data?.pcr_concordance || '--',
                        tooltip: 'A measure of the consistency between multiple laboratory tests of the same sample, ensuring data reliability.',
                        color: getIntactnessRangeCategory(convertToNumber(siteDropDownDetails.eDNA_data?.pcr_concordance || 0)).color
                      },
                    ]
                  }
                ].map((sectionData, sIndex) => (
                  <Grid size={{ xs: 12, md: 3 }} px={1} key={sIndex} sx={{ borderLeft: sIndex > 0 ? '1px solid #D9D9D9' : 'none' }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        component="img"
                        src={sectionData.icon}
                        alt={sectionData.section}
                        sx={{
                          width: "45px",
                          height: "45px",
                          objectFit: "contain",
                          py: 1
                        }}
                      />
                      <Typography sx={{ fontWeight: 600, fontSize: "17px", color: "#151E15", py: 2 }}>
                        {sectionData.section}
                      </Typography>
                    </Box>
                    <Box sx={{ borderTop: '1px solid #D9D9D9', mb: 2 }} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', px: 2, pb: 2 }} gap={2}>
                      {sectionData.metrics.map((metric, mIndex) => (
                        <Box key={mIndex}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '14px' }}>
                              {metric.label}
                            </Typography>
                            <Tooltip title={metric.tooltip} arrow placement="top">
                              <IconButton size="small" sx={{ padding: 0, color: "#666666" }}>
                                <InfoOutlinedIcon sx={{ fontSize: '16px' }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                          <Box>
                            <Typography sx={{ color: metric.color, fontWeight: 500, fontSize: '18px' }}>
                              {metric.value}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>

              {!siteDropDownDetails?.eDNA_data && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.4)',
                    borderRadius: '8px'
                  }}
                >
                  <Typography sx={{ fontWeight: 600, fontSize: '24px', color: '#151E15', opacity: 0.8 }}>
                    Site Not Applicable
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {(currentProject?.project_name === 'Agroforestry Project Dumka' || currentProject?.project_name === "D'ering - Dibru Saikhowa Elephant Link Project" || currentProject?.project_name === 'Mangrove Plantation Initiative in Sundarbans, India') && (
          <SoilSensorCard data={siteDropDownDetails.soil_sensor_data} />
        )}
      </Box>
      <BiodiversityDownloadFilter />
    </Box>
  );
};

export default BiodiversityAnalysisDetail;

